import type { FaireProductEntity } from "../../entity_types/product";

export const p_f5knqz2ph7: FaireProductEntity = {
  token: "p_f5knqz2ph7",
  type: "product",
  name: "Watercolour Fruits Single Playing Card Deck",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/9c456cabf0a7686e43b413150d6a276856dfbe91620ab9859ed9510f6b45988c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7aedf43d5ead6d525697458e4aa054a00f5695e63dbd687c2185047d0661445.jpeg",
    "https://cdn.faire.com/fastly/7357639cf4d8444d0df8c488070e140fb6b69a39268b9ddf4ab2b96add8cf3e8.jpeg",
  ],
  priceDollars: 8,
  description:
    'This Single Deck of 52 Playing Cards features stunning watercolour illustrations from a French book about flowers and fruits first published in 1830. Roomytown\'s design team in Bath, UK have hand picked the most captivating fruit illustrations from this vintage treasure to create this unique Playing Card deck with each card individually designed. Includes standard 52-card deck plus 2 jokers. Packaged in a stylish portable pull-drawer box, it makes an ideal gift.\n\nH 104mm x W 76.2mm x D 30.4mm / H 4.1" x W 3.0" x D 1.2"',
  tags: [],
  msrpDollars: 17.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:40.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
